const SobreNosotros = () => {
  return (
    <div style={{
      display: 'flex',
      height: '80vh',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#f5f7fa',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      color: '#1e3a8a',
      textAlign: 'center',
      padding: '20px',
    }}>
      <h1 style={{
        fontSize: '4rem',
        fontWeight: '900',
        letterSpacing: '3px',
      }}>
        Estamos en mantenimiento...
      </h1>
    </div>
  );
};

export default SobreNosotros;

